/**
 * SoWhatCaption — every chart has a one-liner explaining "so what".
 *
 * In production this is generated by Ollama from the underlying data.
 * In the mock, captions are hand-written in mock-insights-data.ts.
 *
 * Renders as a muted line under the chart title with a small AI-spark icon
 * to indicate it's auto-generated.
 */

import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface SoWhatCaptionProps {
  text: string;
  className?: string;
}

export function SoWhatCaption({ text, className }: SoWhatCaptionProps) {
  return (
    <p className={cn(
      'text-[11px] text-muted-foreground leading-relaxed flex items-start gap-1.5',
      className,
    )}>
      <Sparkles className="h-3 w-3 text-violet-500 dark:text-violet-400 shrink-0 mt-0.5" />
      <span>{text}</span>
    </p>
  );
}
